// Closing matters in bulk — the Matters list's Change status to: → Closed
// (James 2026-10-20, "Require one closing note").  The bulk close asks for ONE
// closing note and sends it as `closing_notes`; the API
// (PUT /api/matters/bulk/status) saves it, trimmed, as the closing notes of
// every matter it closes — the column Close Matter writes — and refuses a
// missing, blank or longer note (400, nothing changes).  The maximum is the
// API's CLOSING_NOTE_MAX_LENGTH (api/src/lib/matterStatus.js);
// matterCloseNoteRules.test.js fails if the two drift apart.  The pre-close
// checklist stays with Close Matter on each matter page.
export const CLOSING_NOTE_MAX_LENGTH = 4000

// The useAsk() options for the bulk close's note: a required text box (OK
// stays disabled while it is blank), capped at the API's maximum.  Resolves to
// the typed text, or null on Cancel.
export function bulkCloseNoteOptions (count) {
  const n = Number(count) || 0
  return {
    type: 'textarea',
    title: `Close ${n} matter${n === 1 ? '' : 's'}?`,
    message:
      'Write one closing note. It is saved as the closing notes of every matter this closes, and in the Audit Log.\n\n' +
      'Any matter with a non-zero trust balance will be REJECTED (Rule 1.15); you can then override with a written reason. ' +
      'The pre-close checklist is on Close Matter, on each matter page.',
    placeholder: 'e.g. Matter resolved. Settlement paid. File archived.',
    required: true,
    maxLength: CLOSING_NOTE_MAX_LENGTH,
    confirmLabel: 'Close matters',
    danger: true,
  }
}
